export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-active')) {
      $('.js-nav-items').slideUp(speed);
      $('.js-nav-items .js-nav-close').remove();
      $('.js-nav-items').removeClass('nav-items-active');
      $(this).removeClass('nav-trigger-active');
    } else {
      $('.js-nav-items').css('display', 'flex');
      $('.js-nav-items').addClass('nav-items-active');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.js-nav-items').on('click touch', '.js-nav-close svg', function() {
    $('.js-nav-items').slideUp(speed);
    $('.js-nav-items .js-nav-close').remove();
    $('.js-nav-items').removeClass('nav-items-active');
    $('.js-nav-mobile-button').removeClass('nav-trigger-active');
  })

  $('.nav .menu-item-has-children').click(function () {
    if ($(window).width() < 1024) {
      $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
        $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
      });
      $(this).children('.sub-menu').slideToggle(speed);
      $(this).toggleClass('menu-item-has-children--active');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.nav .sub-menu').is(":visible")) {
        $('.nav .sub-menu').slideUp(speed);
        $('.nav .menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
      if($('.js-nav-items').hasClass('nav-items-active')) {
        $('.js-nav-items').slideUp(speed);
        $('.js-nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).width() >= 1024 ) {
      $('.js-nav-items').css('display', 'flex');
    } else {
      $('.js-nav-items').css('display', 'none');
      $('.js-nav-items').removeClass('nav-items-active');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    }
  })

  $(window).scroll(function() {
    var header = $('.header'),
        scroll = $(window).scrollTop();

    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
